import React, { PureComponent, Fragment } from 'react';

// import ReactEcharts from "echarts-for-react";
import ReactEcharts from "echarts-for-react";





export default class BiaxialLineChart extends PureComponent {

  constructor(props) {
    super(props);

    var chartData = this.parseData(this.props.data);

    this.state = {
        yearList : chartData.yearList,
        booksValueList : chartData.booksValueList,
        playkitValueList : chartData.playkitValueList,
        kidsfarmValueList : chartData.kidsfarmValueList,
        experienceValueList : chartData.experienceValueList,
        sumValueList : Array.from(chartData.yearList, () => 0),
        unselectedList : [],

        maxValue : chartData.maxValue
    }
  }

  componentWillReceiveProps = (nextProps) => {
      
      var chartData = this.parseData(nextProps.data) ;

      this.setState({
        yearList : chartData.yearList,
        booksValueList : chartData.booksValueList,
        playkitValueList : chartData.playkitValueList,
        kidsfarmValueList : chartData.kidsfarmValueList,
        experienceValueList : chartData.experienceValueList,
        sumValueList : Array.from(chartData.yearList, () => 0),

        maxValue : chartData.maxValue
      });
  }


  containsList = (element) => {
    for (var i = 0; i < this.state.unselectedList.length; i++) {
      if (this.state.unselectedList[i] == element) {
        return i;
      }
    }
    return -1;
  }

  parseData = (chartData) => {
    var maxValue = 300;

    var yearList = [];
    var booksValueList = [];
    var playkitValueList = [];
    var kidsfarmValueList = [];
    var experienceValueList = [];

    chartData.forEach(year => {
      yearList.push(year.name);
      booksValueList.push(year["토모동화"]);
      playkitValueList.push(year["플레이키트"]);
      kidsfarmValueList.push(year["키즈팜"]);
      experienceValueList.push(year["체험관"]);

      if(maxValue < (year["토모동화"]+year["플레이키트"]+year["키즈팜"]+year["체험관"])) {
        maxValue = year["토모동화"]+year["플레이키트"]+year["키즈팜"]+year["체험관"];
      }
    });


    maxValue = Math.ceil(maxValue/100) * 100;

    return {
        yearList : yearList,
        booksValueList : booksValueList,
        playkitValueList : playkitValueList,
        kidsfarmValueList : kidsfarmValueList,
        experienceValueList : experienceValueList,

        maxValue : maxValue
    }
  }



  _onEvent = {
    'legendselectchanged' : (params, chart) => {
      
        var isSelected = params.selected[params.name];
        var index = this.containsList(params.name);
        if (isSelected)
        {
          if (index != -1) {
            this.state.unselectedList.splice(index, 1);
          }
        }
        else
        {
          if (index == -1) {
            this.state.unselectedList.push(params.name);
          }
        }

        chart.setOption({ animation: true });
    }
  }


  render() {

    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            },
            formatter : (params, chart, test) => {
                
                var tooltipHtml = "";

                params.map(e => {
                    if(!tooltipHtml) tooltipHtml += e.name + "<br/>";

                    if(e.seriesName !=="Sum") {
                        tooltipHtml += e.marker + e.seriesName + " : "  + e.value.toLocaleString(); 
                        if(e.componentSubType === "line") tooltipHtml += " %";

                        tooltipHtml += " <br/>";
                    }

                });
                return tooltipHtml;
            }
        },
        legend: {
            data: ['토모동화', '플레이키트', '키즈팜', '체험관']
        },
        xAxis: [
            {
                type: 'category',
                data: this.state.yearList,
                axisPointer: {
                    type: 'shadow'
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '수량(건)',
                min: 0,
                max: this.state.maxValue,
                interval: this.state.maxValue / 5,
                axisLabel: {
                    formatter: (value) => {
                        return value.toLocaleString();
                    }
                }
            }
        ],
        series: [
            {
                name: '토모동화',
                type: 'bar',
                stack: 'one',
                data: this.state.booksValueList,
                label: {
                  show: false,
                  position : "insideTop",
                    formatter: (param) => { 
                        if(param.value === 0) {
                            return "";    
                        } else {
                            return param.value.toLocaleString();
                        }
                    }
                }
            },
            {
                name: '플레이키트',
                type: 'bar',
                stack: 'one',
                data: this.state.playkitValueList,
                label: {
                  show: false,
                  position : "insideTop",
                    formatter: (param) => { 
                        if(param.value === 0) {
                            return "";    
                        } else {
                            return param.value.toLocaleString();
                        }
                    }
                }
            },
            {
                name: '키즈팜',
                type: 'bar',
                stack: 'one',
                data: this.state.kidsfarmValueList,
                label: {
                  show: false,
                  position : "insideTop",
                    formatter: (param) => { 
                        if(param.value === 0) {
                            return "";    
                        } else {
                            return param.value.toLocaleString();
                        }
                    }
                }
            },
            {
                name: '체험관',
                type: 'bar',
                stack: 'one',
                data: this.state.experienceValueList,
                label: {
                  show: false,
                  position : "insideTop",
                    formatter: (param) => { 
                        if(param.value === 0) {
                            return "";    
                        } else {
                            return param.value.toLocaleString();
                        }
                    }
                }
            },
            {
                name: 'Sum',
                type: 'bar',
                stack: 'one',
                data: this.state.sumValueList,
                color: '#00fff',
                label : {
                    show : true,
                    position : "top",
                    formatter: (params) => {
                        let total = 0;
                        option.series.forEach(serie => {
                          if (serie.stack == 'one' && this.containsList(serie.name) == -1) {
                              total += serie.data[params.dataIndex];
                          }
                        })
                        return total.toLocaleString();
                    }
                }
            }
        ]
      };


    return (
      <ReactEcharts theme="macarons" option={option} onEvents={this._onEvent} />
    );
  }
}
